module.exports = __webpack_public_path__ + "img/naira.d5a42bc1.svg";